import React from "react"
import styled from 'styled-components';

interface IProps { title: string }

const Submenu: React.FC<IProps> = ({ title, children }) => {
  return (
    <MenuWrapper>
      <div className="sub-menu-title">{title}</div>
      <ul>
        {children}
      </ul>
    </MenuWrapper>
  )
}

const MenuWrapper = styled.div`
  border: #b7b1a4 solid 1px;
  display: flex;
  flex-direction: column;
  margin-bottom: 2px;
  & .sub-menu-title {
    color: #ffffff;
    background: #005daa;
    text-align: left;
    padding: 6px;
    margin-bottom: 2px;
  }
`

export default Submenu

